module.exports = __webpack_public_path__ + "static/img/island.79c88c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/island.jpg
// module id = zUZo
// module chunks = 1